import type { I18n } from '@lingui/core';
import { msg } from '@lingui/core/macro';

import getBrandDisplayName from '@rover/shared/js/utils/getBrandDisplayName';

/**
 * Copy for the two verification flows. `compulsory` means the account cannot be
 * used until the email is verified, so the wording states that consequence and
 * the page offers a log out instead of a skip.
 */
export const headerText = (i18n: I18n, isCompulsory: boolean): string => {
  const brandDisplayName = getBrandDisplayName();

  return isCompulsory
    ? i18n._(msg`Verify your email to set up your ${brandDisplayName} account`)
    : i18n._(msg`Verify your email to secure your account`);
};

export const descriptionText = (i18n: I18n, userEmail: string, isCompulsory: boolean): string => {
  const brandDisplayName = getBrandDisplayName();

  return isCompulsory
    ? i18n._(
        msg`Enter the verification code ${brandDisplayName} sent to ${userEmail}. Check your spam folder if you don't see it. You will not be able to book with ${brandDisplayName} until you complete this step.`
      )
    : i18n._(
        msg`We just sent a verification code to ${userEmail}. Check your spam folder if you don't see it in your inbox`
      );
};
